<script>
/*
    Give user feedback
    WARNING: do not import vu-app
 */

class FeedbackClass {
    page = reactive({
        active: null,
        dialog: null,
        message: null,
        severity: null,
        severityStyle: null,
    })
    timeout = null

    constructor() {
        this.page.dialog = true
    }

    away() {
        this.clear()
        return true
    }

    clear() {
        if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
        }
        this.page.active = false
    }

    error(msg, context) {
        this.init('error', msg)
    }

    init(sev, msg) {
        if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
        }
        let page = this.page
        page.severity = sev
        page.severityStyle = `feedback-common feedback-${sev}`
        page.message = msg
        page.active = true
        if (sev != 'error') {
            this.timeout = setTimeout(() => { this.clear() }, 10 * 1000)
        }
    }

    info(msg) {
        this.init('info', msg)
    }

    response(response, message) {
        if (response) {
            if (typeof message == 'object' && message.message) {
                message = message.message
            }
            this.init(response.status == 200 ? 'info' : 'error', message)
        }
    }

    warn(msg) {
        this.init('warn', msg)
    }
}
const Feedback = new FeedbackClass()
export {Feedback}
</script>

<script setup>
import {onMounted, onUnmounted, reactive} from 'vue'

const page = Feedback.page

onMounted(() => {
    document.body.addEventListener('click', Feedback.away.bind(Feedback))
})

onUnmounted(() => {
    document.body.removeEventListener('click', Feedback.away.bind(Feedback))
})
</script>

<template>
    <div class="feedback">
        <v-dialog v-model="page.active" location="bottom"
            content-class="feedback-dialog" :scrim="false">
            <v-alert class="vrow" :class="page.severityStyle" :type="page.severity">{{ page.message }}</v-alert>
        </v-dialog>
    </div>
</template>

<style lang="scss">
.feedback-dialog {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    display: block;
    .v-alert {
        border-radius: 4px !important;
        top: 0;
        padding: 20px;
        font-weight: bold;
        font-size: 1.2em;
        text-align: center;
        z-index: 200;
    }
    .feedback-common {
        position: relative;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .feedback-common:empty {
        display: none;
    }
    .feedback-error {
        background-color: rgb(var(--v-theme-error)) !important;
        color: rgb(var(--v-theme-on-error)) !important;
    }
    .feedback-warn {
        background-color: rgb(var(--v-theme-warning)) !important;
        color: rgb(var(--v-theme-on-warning)) !important;
    }
    .feedback-info {
        background-color: rgb(var(--v-theme-primary)) !important;
        color: rgb(var(--v-theme-on-primary)) !important;
    }
}
</style>
